var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.landing)?_c('CompanyPageLandingNew',{attrs:{"editable":false}}):_c('div',[_vm._v("\n  Not found\n")])}
var staticRenderFns = []

export { render, staticRenderFns }